
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M21 17H20V11C20 9.90003 19.1 9.00003 18 9.00003H7V8.26003C7 7.80003 6.44 7.56003 6.11 7.89003L4.37 9.63003C4.17 9.83003 4.17 10.16 4.37 10.37L6.11 12.11C6.44 12.44 7 12.21 7 11.74V11H11V14H5C4.45 14 4 14.45 4 15V17C4 18.1 4.9 19 6 19H8C8 20.66 9.34 22 11 22C12.66 22 14 20.66 14 19H21C21.55 19 22 18.55 22 18C22 17.45 21.55 17 21 17ZM11 20C10.45 20 10 19.55 10 19C10 18.45 10.45 18 11 18C11.55 18 12 18.45 12 19C12 19.55 11.55 20 11 20ZM18 14H14V11H17C17.55 11 18 11.45 18 12V14ZM10 6.00003H17V6.74003C17 7.20003 17.56 7.44003 17.89 7.11003L19.63 5.37003C19.83 5.17003 19.83 4.84003 19.63 4.63003L17.89 2.89003C17.56 2.56003 17 2.79003 17 3.26003V4.00003H10C9.45 4.00003 9 4.45003 9 5.00003C9 5.55003 9.45 6.00003 10 6.00003Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-rv-hookup`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconRvHookup

    ```js
    <b-new-b-icon-rv-hookup />
    ```
</docs>


